import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "tw-w-full tw-bg-gray-50 ResultadosCard" }
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-flex-1 tw-gap-3 tw-h-full" }
const _hoisted_3 = { class: "tw-flex tw-flex-col md:tw-flex-row tw-gap-3" }
const _hoisted_4 = { class: "tw-w-full md:tw-text-left! tw-flex tw-flex-col tw-items-center md:tw-items-start tw-justify-center" }
const _hoisted_5 = { class: "tw-flex tw-flex-col tw-gap-1" }
const _hoisted_6 = {
  style: {"text-transform":"capitalize"},
  class: "tw-font-bold tw-text-lg"
}
const _hoisted_7 = {
  key: 0,
  class: "tw-flex tw-gap-1"
}
const _hoisted_8 = {
  style: {"text-transform":"capitalize"},
  class: "tw-font-medium tw-text-sm"
}
const _hoisted_9 = {
  style: {"color":"var(--primary-color)"},
  class: "tw-font-medium tw-text-sm"
}
const _hoisted_10 = { class: "tw-mx-auto md:tw-ml-auto md:tw-flex-col tw-flex-wrap tw-flex tw-gap-2 tw-text-sm" }
const _hoisted_11 = {
  style: {"color":"var(--primary-color)","white-space":"nowrap"},
  class: "tw-mx-auto tw-text-center tw-font-semibold"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"1.5em","color":"var(--primary-color)"},
  class: "pi pi-file-pdf tw-ml-auto"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  style: {"color":"var(--primary-color)","white-space":"nowrap"},
  class: "tw-mx-auto tw-text-center tw-font-semibold"
}, "Ver Imagen", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"1.5em","color":"var(--primary-color)"},
  class: "pi pi-image tw-ml-auto"
}, null, -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "tw-w-full tw-mt-auto tw--mb-6 tw-flex tw-flex-col tw-gap-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_18 = { class: "tw-w-full tw-flex tw-items-center tw-justify-center tw-gap-2 tw-text-sm tw-text-indigo-500 tw-cursor-pointer" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "tw-w-full" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Aceptar")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_resultado_info = _resolveComponent("resultado-info")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { class: "p-shadow-5 tw-h-full" }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.nombreEstudio), 1)
                ]),
                (_ctx.practica)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.practica?.descripcion?.toLowerCase()), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.fecha), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_ctx.hasInforme)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit("ver"))),
                    class: "tw-max-w-min md:tw-max-w-none tw-shadow-sm tw-flex tw-gap-3 tw-items-center tw-justify-center tw-cursor-pointer tw-select-none tw-w-full tw-px-4 tw-py-2 tw-border tw-border-gray-400 tw-rounded"
                  }, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.isPac || _ctx.isExterno ? 'Descargar Inf.' : 'Descargar PDF'), 1),
                    _hoisted_12
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isPac && _ctx.verImagenesEstudios)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit("visualizar"))),
                    class: "tw-max-w-min md:tw-max-w-none tw-shadow-sm tw-flex tw-items-center tw-justify-center tw-gap-3 tw-cursor-pointer tw-select-none tw-w-full tw-border tw-border-gray-400 tw-px-4 tw-py-2 tw-rounded"
                  }, _hoisted_15))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extraItems, (item, index) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: item,
                  onClick: item.command,
                  class: _normalizeClass(["tw-select-none tw-flex tw-gap-2 tw-items-center", {"tw-border-l tw-border-indigo-500 tw-pl-2":index }])
                }, [
                  _createElementVNode("a", null, _toDisplayString(item.label), 1),
                  _createElementVNode("i", {
                    class: _normalizeClass([item.icon,"tw-text-xs tw-font-semibold"])
                  }, null, 2)
                ], 10, _hoisted_19))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Dialog, {
      closable: true,
      modal: true,
      appendTo: "self",
      header: "Información",
      visible: _ctx.showInfo,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showInfo) = $event))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_Button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showInfo = false))
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (_ctx.showInfo)
          ? (_openBlock(), _createBlock(_component_resultado_info, {
              key: 0,
              id: _ctx.datos?._id
            }, null, 8, ["id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}